import React, { useState, useCallback } from 'react';
import { Provider } from 'react-redux';
import axios from 'axios';
import store from '../../store';
import styled from 'styled-components';
import { Route, Redirect } from 'react-router-dom';
import PortalRoot from 'shared/components/PortalRoot';
import DonorNavTabs from './DonorNavTabs';
import Home from './Home';
import { Ir } from './Ir';
import QuickSight from './QuickSight';
import Strategy from './Strategy';
// import DashboardList from '../../containers/DashboardList';
import DashboardLegacy from '../../containers/DashboardLegacy';
import FlexibleReport from '../../containers/FlexibleReport';
import ErrorBoundary from '../../utils/ErrorBoundary';
import { useMyCustomPortal } from 'shared/apollo';
import { signOut } from 'shared/auth';
import Contributions from 'shared/account/pages/Contributions';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import FeedbackDashboard from './FeedbackDashboard';
import Feedback from './FeedbackDashboard/Feedback';
import Dashboard from './Dashboard';
import DonorReceipt from './DonorReceipt';
import { IndicatorProvider } from 'shared/providers/IndicatorProvider';
import ReportProvider from 'shared/providers/ReportProvider';

setInterval(() => {
  axios.get('v4/accounts/me').catch(e => {
    const event = new CustomEvent('generalError', {
      detail: {
        error:
          'Your session has expired. to keep the current session open, please reload the page',
        title: 'Session Expired',
      },
    });
    document.getElementById('root').dispatchEvent(event);
  });
}, 300000);

export default function Routes() {
  const [dialog, setDialog] = useState();
  const customPortal = useMyCustomPortal();

  const closeDialog = useCallback(() => {
    setDialog();
  }, []);

  const reloadPage = () => {
    setDialog();
    window.open('/', '_self');
  };

  document.getElementById('root').addEventListener(
    'generalError',
    ({ detail }) => {
      setDialog(detail);
    },
    false,
  );

  return (
    <Provider store={store}>
      <IndicatorProvider>
        <Route
          path="/ir-frame/:investmentId"
          render={props => (
            <ErrorBoundary>
              <Ir {...props} />
            </ErrorBoundary>
          )}
        />
        <Route path="/donor">
          <PortalRoot title="True Impact: Donor Portal" nav={<DonorNavTabs />}>
            <Route
              path="/donor/home"
              render={props => (
                <ErrorBoundary>
                  <Home {...props} customPortal={customPortal} />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/donor/custom"
              render={props => (
                <ErrorBoundary>
                  <Home {...props} customPortal={customPortal} />
                </ErrorBoundary>
              )}
            />
            {/*<Route
            path="/donor/dashboards"
            component={DashboardList}
          />*/}
            <Route
              path="/donor/reporting"
              render={() => (
                <ErrorBoundary>
                  <FlexibleReport />
                </ErrorBoundary>
              )}
            />
            <Route
              exact={true}
              path="/donor/dashboard"
              render={() => (
                <ErrorBoundary>
                  <Dashboard type="donor" />
                </ErrorBoundary>
              )}
            />
            <Route
              exact={true}
              path="/donor/feedback"
              render={() => (
                <ErrorBoundary>
                  <FeedbackDashboard type="donor" />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/donor/feedback/:feedbackId"
              render={props => (
                <ErrorBoundary>
                  <ReportProvider>
                    <IndicatorProvider>
                      <Feedback {...props} userType="donor" />
                    </IndicatorProvider>
                  </ReportProvider>
                </ErrorBoundary>
              )}
            />
            <Route
              path="/donor/quicksight"
              render={() => (
                <ErrorBoundary>
                  <QuickSight />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/donor/strategy"
              render={() => (
                <ErrorBoundary>
                  <Strategy />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/donor/ir/:investmentId"
              render={props => (
                <ErrorBoundary>
                  <Ir {...props} />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/donor/impact-receipt/:investmentId"
              render={props => (
                <ErrorBoundary>
                  <DonorReceipt {...props} />
                </ErrorBoundary>
              )}
            />
            <Route
              path="/donor/investment-upload"
              render={() => <Contributions />}
            />
          </PortalRoot>
        </Route>
        <Route
          path="/donor/dashboard-legacy"
          render={() => (
            <ErrorBoundary>
              <DashboardLegacy />
            </ErrorBoundary>
          )}
        />
        <Route exact path="/">
          <Redirect to="/donor/home" />
        </Route>
        <Dialog open={dialog} onClose={closeDialog}>
          <DialogTitle>{dialog?.title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{dialog?.error}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={signOut} color="primary">
              Cancel
            </Button>
            <Button onClick={reloadPage} color="primary">
              Reload
            </Button>
          </DialogActions>
        </Dialog>
      </IndicatorProvider>
    </Provider>
  );
}

const TopMenu = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  line-height: 48px;
  padding: 0 20px;
  z-index: 1;
`;

export const Logo = styled.img.attrs({
  alt: 'Logo',
  src: '/images/svg/logo_primary.svg',
})`
  position: absolute;
  top: 0;
  left: 0;
  height: 48px;
  padding: 12px 20px;
`;
